module.exports = __webpack_public_path__ + "static/media/32.409b7e64.jpeg";